var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMindmap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    viewBox: "0 0 14 15",
    className: "transition-colors duration-300 fill-[#2E2E2E] st-current",
    width: 14,
    height: 14,
    "data-label": "svg.transition-colors",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.804 2.802a.583.583 0 0 1-.37.738c-.22.074-.374.235-.499.548-.134.335-.199.754-.275 1.248l-.003.023c-.054.35-.117.761-.243 1.128h.836a.583.583 0 0 1 0 1.166h-.836c.126.367.189.778.243 1.128l.003.023c.076.494.141.913.275 1.249.125.313.28.474.5.547a.583.583 0 1 1-.37 1.107c-.654-.218-1.01-.714-1.213-1.221-.185-.463-.268-1-.335-1.442l-.01-.062c-.077-.5-.14-.859-.258-1.1a.452.452 0 0 0-.135-.182c-.028-.02-.081-.047-.197-.047H1.751a.584.584 0 0 1 0-1.166h1.166c.116 0 .169-.027.197-.047a.452.452 0 0 0 .135-.181c.118-.242.181-.6.258-1.1l.01-.062c.067-.443.15-.98.335-1.443.203-.507.56-1.002 1.214-1.22a.583.583 0 0 1 .738.368zM7 2.987c0-.322.261-.584.584-.584h4.666a.583.583 0 1 1 0 1.167H7.584A.583.583 0 0 1 7 2.987zM7 7.07c0-.322.261-.583.584-.583h4.666a.583.583 0 1 1 0 1.166H7.584A.583.583 0 0 1 7 7.07zm0 4.083c0-.322.261-.583.584-.583h4.666a.583.583 0 0 1 0 1.167H7.584A.583.583 0 0 1 7 11.153z",
    clipRule: "evenodd",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindmap);
export default __webpack_public_path__ + "static/media/mindmap.b98731fca741fd521344a07477a44ed8.svg";
export { ForwardRef as ReactComponent };